module.exports = __webpack_public_path__ + "static/media/ic_curl_command_error.1b7c6dea.svg";